(function () {
  const MEDIA_THUMBS = {
    'Framed Paper Print': 'thumb_printandframe2.jpg',
    'Framed Canvas Print': 'thumb_canvas.jpg',
    'Unframed Paper Print': 'thumb_printonly.jpg',
  };

  const FRAME_THUMBS = {
    'Framed Paper Print': {
      White: 'thumb_white_frame.jpg',
      Black: 'thumb_black_frame.jpg',
      Oak: 'thumb_oak_frame.jpg',
    },
    'Framed Canvas Print': {
      White: 'thumb_white_canvas.jpg',
      Black: 'thumb_black_canvas.jpg',
      Oak: 'thumb_oak_canvas.jpg',
    },
  };

  const OPTION_MEDIA = 'Media';
  const OPTION_SIZE = 'Size';
  const OPTION_FRAMES = 'Frames';

  function getAssetsBase() {
    const script = document.querySelector('script[data-assets-url]');
    return script ? script.getAttribute('data-assets-url') : '';
  }

  function getProductJSON(container) {
    const section = container.closest('[data-section-type], [data-section-id], .shopify-section');
    if (!section) return null;
    const script = section.querySelector('[data-product-json]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function findOptionGroup(container, optionName) {
    const legends = container.querySelectorAll('.radio__legend__option-name');
    for (const legend of legends) {
      if (legend.textContent.trim() === optionName) {
        return legend.closest('.selector-wrapper');
      }
    }
    return null;
  }

  function getSelectedValue(group) {
    if (!group) return null;
    const checked = group.querySelector('input[type="radio"]:checked, input[type="hidden"]');
    return checked ? checked.value : null;
  }

  function selectOption(group, value) {
    if (!group) return;
    const input = group.querySelector(`input[value="${CSS.escape(value)}"]`);
    if (input && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function getOptionPosition(product, optionName) {
    if (!product || !product.options) return -1;
    return product.options.indexOf(optionName);
  }

  function getAvailableValuesForOption(variants, fixedPositions) {
    const values = new Set();
    variants.forEach((v) => {
      const matches = fixedPositions.every(
        ({ position, value }) => v.options[position] === value
      );
      if (matches) {
        fixedPositions.forEach(() => {});
        values.add(true);
      }
    });
    return values;
  }

  function getSizesForMedia(product, mediaValue) {
    const mediaPos = getOptionPosition(product, OPTION_MEDIA);
    if (mediaPos === -1) return new Set();
    const sizePos = getOptionPosition(product, OPTION_SIZE);
    if (sizePos === -1) return new Set();

    const sizes = new Set();
    product.variants.forEach((v) => {
      if (v.options[mediaPos] === mediaValue) {
        sizes.add(v.options[sizePos]);
      }
    });
    return sizes;
  }

  function getFramesForMedia(product, mediaValue) {
    const mediaPos = getOptionPosition(product, OPTION_MEDIA);
    if (mediaPos === -1) return new Set();
    const framesPos = getOptionPosition(product, OPTION_FRAMES);
    if (framesPos === -1) return new Set();

    const frames = new Set();
    product.variants.forEach((v) => {
      if (v.options[mediaPos] === mediaValue) {
        frames.add(v.options[framesPos]);
      }
    });
    return frames;
  }

  function injectStyles() {
    const style = document.createElement('style');
    style.textContent = `
      .selector-wrapper--always-visible .radio__button input.unavailable + label,
      .selector-wrapper--always-visible .radio__button input.sold-out + label {
        background-color: transparent !important;
        color: inherit !important;
        opacity: 1 !important;
      }
      .selector-wrapper.is-hidden {
        display: none !important;
      }
      .radio__button.is-hidden,
      radio-swatch.is-hidden {
        display: none !important;
      }
      .selector-wrapper--always-visible .radio__legend {
        display: none;
      }
      .selector-wrapper--always-visible .radio__fieldset {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
      }
      .selector-wrapper--always-visible .radio__buttons {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
      }
      .radio__button.has-media-thumb {
        padding: 0;
      }
      .radio__button.has-media-thumb label {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
        padding: 6px 10px;
        cursor: pointer;
      }
      .radio__button.has-media-thumb .media-thumb {
        width: 120px;
        height: 80px;
        object-fit: cover;
        border-radius: 4px;
        display: block;
      }
      .radio__button.has-media-thumb .option-title {
        font-size: 0.8em;
        text-align: center;
        line-height: 1.2;
        max-width: 120px;
      }
    `;
    document.head.appendChild(style);
  }

  function injectMediaThumbnails(mediaGroup, assetsBase) {
    if (!mediaGroup) return;
    const buttons = mediaGroup.querySelectorAll('.radio__button');
    buttons.forEach((btn) => {
      if (btn.querySelector('.media-thumb')) return;
      const input = btn.querySelector('input[type="radio"]');
      if (!input) return;
      const value = input.value;
      const thumbFile = MEDIA_THUMBS[value];
      if (!thumbFile) return;

      btn.classList.add('has-media-thumb');
      const label = btn.querySelector('label');
      if (!label) return;
      const img = document.createElement('img');
      img.src = assetsBase + thumbFile;
      img.alt = value;
      img.className = 'media-thumb';
      img.loading = 'eager';
      label.prepend(img);
    });
  }

  function updateFrameSwatches(framesGroup, mediaValue, assetsBase) {
    if (!framesGroup) return;
    const thumbMap = FRAME_THUMBS[mediaValue];
    if (!thumbMap) return;

    const swatches = framesGroup.querySelectorAll('radio-swatch');
    swatches.forEach((swatch) => {
      const input = swatch.querySelector('input[type="radio"]');
      if (!input) return;
      const frameValue = input.value;
      const thumbFile = thumbMap[frameValue];
      if (thumbFile) {
        const imgUrl = `url(${assetsBase}${thumbFile})`;
        swatch.style.setProperty('--swatch', imgUrl);
        const label = swatch.querySelector('label');
        if (label) {
          label.style.background = `${imgUrl} no-repeat center center / cover`;
        }
      }
    });
  }

  function filterSizes(sizeGroup, product, mediaValue) {
    if (!sizeGroup) return;
    const availableSizes = getSizesForMedia(product, mediaValue);
    const buttons = sizeGroup.querySelectorAll('.radio__button');
    let selectedIsHidden = false;

    buttons.forEach((btn) => {
      const input = btn.querySelector('input[type="radio"]');
      if (!input) return;
      if (availableSizes.has(input.value)) {
        btn.classList.remove('is-hidden');
      } else {
        btn.classList.add('is-hidden');
        if (input.checked) selectedIsHidden = true;
      }
    });

    if (selectedIsHidden) {
      const firstVisible = sizeGroup.querySelector('.radio__button:not(.is-hidden) input[type="radio"]');
      if (firstVisible) {
        selectOption(sizeGroup, firstVisible.value);
      }
    }
  }

  function filterFrames(framesGroup, product, mediaValue) {
    if (!framesGroup) return;

    if (mediaValue === 'Unframed Paper Print') {
      framesGroup.classList.add('is-hidden');
      selectOption(framesGroup, 'Unframed');
      return;
    }

    framesGroup.classList.remove('is-hidden');
    const availableFrames = getFramesForMedia(product, mediaValue);

    const swatches = framesGroup.querySelectorAll('radio-swatch');
    let selectedIsHidden = false;

    swatches.forEach((swatch) => {
      const input = swatch.querySelector('input[type="radio"]');
      if (!input) return;
      const shouldHide = input.value === 'Unframed' || !availableFrames.has(input.value);
      if (shouldHide) {
        swatch.classList.add('is-hidden');
        if (input.checked) selectedIsHidden = true;
      } else {
        swatch.classList.remove('is-hidden');
      }
    });

    if (selectedIsHidden) {
      const firstVisible = framesGroup.querySelector('radio-swatch:not(.is-hidden) input[type="radio"]');
      if (firstVisible) {
        selectOption(framesGroup, firstVisible.value);
      }
    }
  }

  function applyMediaRules(container, product, assetsBase) {
    const mediaGroup = findOptionGroup(container, OPTION_MEDIA);
    const sizeGroup = findOptionGroup(container, OPTION_SIZE);
    const framesGroup = findOptionGroup(container, OPTION_FRAMES);
    if (!mediaGroup) return;

    const mediaValue = getSelectedValue(mediaGroup);
    if (!mediaValue) return;

    filterSizes(sizeGroup, product, mediaValue);
    filterFrames(framesGroup, product, mediaValue);

    if (framesGroup && mediaValue !== 'Unframed Paper Print') {
      updateFrameSwatches(framesGroup, mediaValue, assetsBase);
    }
  }

  function keepMediaAlwaysVisible(mediaGroup) {
    const observer = new MutationObserver(() => {
      mediaGroup.querySelectorAll('input.unavailable, input.sold-out').forEach((input) => {
        input.classList.remove('unavailable', 'sold-out');
      });
    });
    observer.observe(mediaGroup, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  function init() {
    const containers = document.querySelectorAll('[data-product-variants]');
    if (!containers.length) return;

    const assetsBase = getAssetsBase();
    injectStyles();

    containers.forEach((container) => {
      const product = getProductJSON(container);
      if (!product) return;

      const mediaGroup = findOptionGroup(container, OPTION_MEDIA);

      if (mediaGroup) {
        mediaGroup.classList.add('selector-wrapper--always-visible');
        injectMediaThumbnails(mediaGroup, assetsBase);

        mediaGroup.addEventListener('change', () => {
          setTimeout(() => applyMediaRules(container, product, assetsBase), 0);
        });

        keepMediaAlwaysVisible(mediaGroup);
      }

      applyMediaRules(container, product, assetsBase);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
